import React from "react";
import { useTranslation } from "react-i18next";
import { FormBuilder } from "components/FormBuilder/FormBuilder";

const PAGE_LOCALE_KEY = "page.merchants.";
const FORM_LABEL_KEY =
  PAGE_LOCALE_KEY + "merchantDetail.info.accountInfo.fields";

const AccountInfoSession = ({ formProps, isEdit, isLoading }) => {
  const { t } = useTranslation()

  const isDisabled = !isEdit || isLoading

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    validBankAccount: {
      fieldType: "textInput",
      fieldName: "bankAccount",
      label: t(`${FORM_LABEL_KEY}.bankAccount`),
      disabled: isDisabled,
      config: {
        rules: ["validBankAccount"]
      }
    },
    beneficiary: {
      fieldType: "textInput",
      fieldName: "beneficiary",
      label: t(`${FORM_LABEL_KEY}.beneficiary`),
      disabled: isDisabled,
      config: {
        maxLength: 140,
        rules: ["onlyBlockLetter",
          "noLeadingWhitespace",
          "validBankBeneficiary",]
      }
    },

    bankAccountRemarks: {
      fieldType: "textInput",
      fieldName: "bankAccountRemarks",
      label: t(`${FORM_LABEL_KEY}.bankAccountRemarks`),
      disabled: isDisabled,
      config: {
        disableLineBreak: true,
        multiline: true,
        rows: 3,
        maxLength: 255,
        rules: [
          "noLeadingWhitespace",
          "noQuotesOrBackticks",
          "noLineBreaks"
        ],
      },
    }
  }

  return (
    <FormBuilder.Section
      title={t(`${PAGE_LOCALE_KEY}merchantDetail.info.accountInfo.title`)}
      titleVariant="h3">
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            fields: [
              fieldsConfig.validBankAccount,
              fieldsConfig.beneficiary,
            ]
          })
        }
      </FormBuilder.Row>
      <FormBuilder.Row itemsPerRow={1}>
        {
          FormBuilder.buildFields({
            formProps,
            fields: [
              fieldsConfig.bankAccountRemarks,
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  );
};
export default React.memo(AccountInfoSession);
